import CryptoJS from 'crypto-js'
import { btoa } from 'js-base64'

const XOR_KEY = '6Wrs3yZjwd11s7NW0eOVV7YS2UCGXvYk'

/** 将字符串最后一位替换为 str1，用于生成 timestamp 相关值 */
export function handeleStr(str: string, str1: string): string {
  const arr = str.split('')
  arr[arr.length - 1] = str1
  return arr.join('')
}

function string2Uint8Array(str: string): Uint8Array {
  return new TextEncoder().encode(str)
}

/** 异或加密（对象会 JSON 序列化后加密），返回 Base64 */
export function xorEncrypt(data: Record<string, unknown>, key: string = XOR_KEY): string {
  const str = JSON.stringify(data)
  const dataCodes = string2Uint8Array(str)
  const keyCodes = string2Uint8Array(key)
  const outputCodes = dataCodes.map((code, index) => code ^ keyCodes[index % keyCodes.length])
  return btoa(String.fromCharCode(...outputCodes))
}

/** 异或解密 Base64 密文为 JSON 对象 */
export function xorDecrypt(encryptedBase64: string, key: string = XOR_KEY): Record<string, unknown> {
  const binaryString = atob(encryptedBase64)
  const encryptedCodes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    encryptedCodes[i] = binaryString.charCodeAt(i)
  }
  const keyCodes = string2Uint8Array(key)
  const decryptedCodes = encryptedCodes.map((code, index) => code ^ keyCodes[index % keyCodes.length])
  const decryptedString = String.fromCharCode(...decryptedCodes)
  return JSON.parse(decryptedString) as Record<string, unknown>
}

/** 移除对象中空字符串和 null/undefined 的字段 */
export function filterNull<T extends Record<string, unknown>>(obj: T): void {
  for (const i of Object.keys(obj)) {
    if (obj[i] === '' || obj[i] == null) {
      delete obj[i]
    }
  }
}

function cleanArray<T>(actual: (T | undefined | null)[]): T[] {
  return actual.filter(Boolean) as T[]
}

/** 对象转 query 字符串 */
export function toQueryString(obj: Record<string, unknown> | null | undefined): string {
  if (!obj) {
    return ''
  }
  return cleanArray(
    Object.keys(obj).map((key) => {
      if (obj[key] === undefined) {
        return ''
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(String(obj[key]))}`
    }),
  ).join('&')
}

/** 生成请求用的 timestamp（newTime）和 nonstr */
export function getRequestTimestamp(): { newTime: string, nonstr: string } {
  const timestamp = Math.floor(Date.now() / 1000).toString()
  const timestamps = Date.now().toString()
  const newTime = handeleStr(timestamps, timestamp.slice(-1))
  const nonstr = CryptoJS.MD5(`${newTime}_${timestamp.slice(-1)}`).toString()
  return { newTime, nonstr }
}
